/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WeeklyActive } from './WeeklyActive';
import {
    WeeklyActiveFromJSON,
    WeeklyActiveFromJSONTyped,
    WeeklyActiveToJSON,
    WeeklyActiveToJSONTyped,
} from './WeeklyActive';
import type { RoleCount } from './RoleCount';
import {
    RoleCountFromJSON,
    RoleCountFromJSONTyped,
    RoleCountToJSON,
    RoleCountToJSONTyped,
} from './RoleCount';
import type { GradeCount } from './GradeCount';
import {
    GradeCountFromJSON,
    GradeCountFromJSONTyped,
    GradeCountToJSON,
    GradeCountToJSONTyped,
} from './GradeCount';

/**
 * Totals for one organization, as shown on the users page.
 * @export
 * @interface UserMetricsRead
 */
export interface UserMetricsRead {
    /**
     * 
     * @type {number}
     * @memberof UserMetricsRead
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof UserMetricsRead
     */
    active: number;
    /**
     * 
     * @type {number}
     * @memberof UserMetricsRead
     */
    max_users: number;
    /**
     * 
     * @type {Array<RoleCount>}
     * @memberof UserMetricsRead
     */
    by_role: Array<RoleCount>;
    /**
     * 
     * @type {Array<GradeCount>}
     * @memberof UserMetricsRead
     */
    by_grade: Array<GradeCount>;
    /**
     * 
     * @type {WeeklyActive}
     * @memberof UserMetricsRead
     */
    weekly_active: WeeklyActive;
}

/**
 * Check if a given object implements the UserMetricsRead interface.
 */
export function instanceOfUserMetricsRead(value: object): value is UserMetricsRead {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('max_users' in value) || value['max_users'] === undefined) return false;
    if (!('by_role' in value) || value['by_role'] === undefined) return false;
    if (!('by_grade' in value) || value['by_grade'] === undefined) return false;
    if (!('weekly_active' in value) || value['weekly_active'] === undefined) return false;
    return true;
}

export function UserMetricsReadFromJSON(json: any): UserMetricsRead {
    return UserMetricsReadFromJSONTyped(json, false);
}

export function UserMetricsReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMetricsRead {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'active': json['active'],
        'max_users': json['max_users'],
        'by_role': ((json['by_role'] as Array<any>).map(RoleCountFromJSON)),
        'by_grade': ((json['by_grade'] as Array<any>).map(GradeCountFromJSON)),
        'weekly_active': WeeklyActiveFromJSON(json['weekly_active']),
    };
}

export function UserMetricsReadToJSON(json: any): UserMetricsRead {
    return UserMetricsReadToJSONTyped(json, false);
}

export function UserMetricsReadToJSONTyped(value?: UserMetricsRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'active': value['active'],
        'max_users': value['max_users'],
        'by_role': ((value['by_role'] as Array<any>).map(RoleCountToJSON)),
        'by_grade': ((value['by_grade'] as Array<any>).map(GradeCountToJSON)),
        'weekly_active': WeeklyActiveToJSON(value['weekly_active']),
    };
}

